"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  decrypt: () => decrypt,
  generateSign: () => generateSign,
  generateUrl: () => generateUrl
});
module.exports = __toCommonJS(src_exports);
var import_crypto_js = __toESM(require("crypto-js"), 1);
var randomStr = (length = 4, chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ") => {
  let result = "";
  for (let i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};
var generateSign = (config) => {
  const timestamp = Math.floor(new Date().getTime() / 1e3);
  const noncestr = timestamp + randomStr();
  const orgid = config.orgId || 29;
  const secret = config.secret;
  const sign = import_crypto_js.default.MD5(noncestr + timestamp + config.orgId + secret).toString();
  return {
    noncestr,
    timestamp,
    sign,
    orgid
  };
};
var decrypt = (key, word) => {
  const localKey = import_crypto_js.default.enc.Utf8.parse(key);
  const iv = import_crypto_js.default.enc.Utf8.parse("0000000000000000");
  const encryptedHexStr = import_crypto_js.default.enc.Base64.parse(word);
  const srcs = import_crypto_js.default.enc.Base64.stringify(encryptedHexStr);
  const decrypt2 = import_crypto_js.default.AES.decrypt(srcs, localKey, {
    iv,
    mode: import_crypto_js.default.mode.CBC,
    padding: import_crypto_js.default.pad.Pkcs7
  });
  return import_crypto_js.default.enc.Utf8.stringify(decrypt2);
};
var generateUrl = (config) => {
  return addParamsToUrl(config.url || "", generateSign(config));
};
var addParamsToUrl = (url, params) => {
  let result = url + (url.indexOf("?") !== -1 ? "&" : "?");
  for (const key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      result += `${key}=${params[key]}&`;
    }
  }
  return result.substring(0, result.length - 1);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  decrypt,
  generateSign,
  generateUrl
});
//# sourceMappingURL=index.cjs.map